module.exports = __webpack_public_path__ + "static/img/tu2.e60906b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jobs/tu2.png
// module id = tWRN
// module chunks = 1